// This file is automatically generated. Do not edit it directly.
import { createClient } from '@supabase/supabase-js';
import type { Database } from './types';

const SUPABASE_URL = "https://zfwesjddmqulrbenxybp.supabase.co";
const SUPABASE_PUBLISHABLE_KEY = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6Inpmd2VzamRkbXF1bHJiZW54eWJwIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NDgyNDE5NDAsImV4cCI6MjA2MzgxNzk0MH0.yfD8pzJAHKCokP5B6NzLVh1cPp1xM2PCKYq8OBmLahY";

// Import the supabase client like this:
// import { supabase } from "@/integrations/supabase/client";

export const supabase = createClient<Database>(SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY);